import { Trans } from 'react-i18next';

import LandingPageOptionalPaymentElement from '/business/shared/components/widgets/optional-payment-element/LandingPageOptionalPaymentElement';

import StyledParagraph from '/shared/styled/components/StyledParagraph';
import StyledHeading from '/shared/styled/components/StyledHeading';

export default function IntroStep2() {
  return (
    <>
      <StyledHeading $green as="h2" $type="h3" $bold>
        {/* @i18n: Create your reduction plan */}
        <Trans i18nKey="business:GettingStartedPage.step2.heading" />
      </StyledHeading>
      <StyledParagraph>
        {/* @i18n: Identify your emissions hotspots, set reduction targets, explore carbon reduction[...] */}
        <Trans i18nKey="business:GettingStartedPage.step2.para1" />
      </StyledParagraph>
      <StyledParagraph>
        {/* @i18n: Your reduction plan can be downloaded at any point. */}
        <Trans i18nKey="business:GettingStartedPage.step2.para2" />
      </StyledParagraph>
      <StyledHeading $bold as="h2" $type="h6">
        {/* @i18n: Learn more about bp lower carbon reduction solutions */}
        <Trans i18nKey="business:GettingStartedPage.step2.subHeading.title" />
      </StyledHeading>
      <StyledParagraph>
        {/* @i18n: We'll assess the availability of solutions in your region and if appropriate, we will[...] */}
        <Trans i18nKey="business:GettingStartedPage.step2.subHeading.para" />
      </StyledParagraph>
      <LandingPageOptionalPaymentElement />
    </>
  );
}
